"use client";
import React, { useEffect, useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import Link from "next/link";
import CommonImage from "@/components/common/image/CommonImage";
import CustomPagination from "@/components/common/Pagination/CustomPagination";
import HomePageService from "@/services/api/HomeService";
import { slugy } from "@/utils/slugify";

export default function StudentReview() {
  const [studentReviews, setStudentReviews] = useState([]);
  console.log("studentReviews", studentReviews);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideoLink, setCurrentVideoLink] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  console.log("currentPage", currentPage);

  const [loading, setLoading] = useState(false);

  const openModal = (review) => {
    setCurrentVideoLink(review.video_link);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentVideoLink(null);
  };

  const fetchStudentReviews = async (page = 1) => {
    setLoading(true);
    try {
      const response = await HomePageService.getStudentReview({ page });
      console.log("response", response);
      setStudentReviews(response.data || []);
      setTotalItems(response.total || 0);
      setCurrentPage(response.current_page);
      setPageSize(response.per_page || pageSize);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentReviews(currentPage);
  }, [currentPage]);

  return (
    <section className="success-student_section bg-animation success-student-page section_padding">
      <div className="container">
        <div className="section-title-wrap">
          <div className="section_title">
            <h2 className="title">
              <span className="w-8 h-8">
                <CommonImage
                  src="/images/admission-icon/student-success-icon.png"
                  className="img-icon"
                  alt="Book Icon"
                />
              </span>
              শিক্ষার্থীদের অভিমত
            </h2>
          </div>
        </div>
        <div className="section-content-wrap">
          <div className="students-opinions">
            {studentReviews?.map((review, index) => (
              <div className="student-opinion" key={index}>
                <div className="student-information">
                  <CommonImage
                    src={review.image || "/images/home/student-image.png"}
                    className="student-image"
                    alt="Student Image"
                  />

                  <div className="name-title">
                    <h3 className="name">{review.name}</h3>
                    <p className="title">{review.relation}</p>
                  </div>
                </div>
                <div className="opinion">
                  <p className="opinion-text">
                    {review?.description.length > 100
                      ? review.description.substring(0, 100) + "..."
                      : review.description}{" "}
                     <Link href={`/reviews/${review?.id}/${slugy(review.name)}`} className="link">
                      আরো....
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
          <CustomPagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalItems={totalItems}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </section>
  );
}
